import { createFileRoute } from '@tanstack/react-router';
import { MyReviewsScreen } from '@/features/reviews/MyReviewsScreen.tsx';
import { requireAuth } from '@/features/auth/guard.ts';

export const Route = createFileRoute('/_app/profile/reviews')({
  beforeLoad: requireAuth,
  component: MyReviewsScreen,
});
